import { ComboboxInput } from "@headlessui/react-v2";
import classNames from "classnames";
import type { ChangeEvent, ComponentPropsWithoutRef } from "react";

export interface InputProps<T = unknown> extends Omit<
  ComponentPropsWithoutRef<"input">,
  "defaultValue"
> {
  displayValue: (value: T) => string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Input = <T,>({
  displayValue,
  onChange,
  className,
  ...rest
}: InputProps<T>) => (
  <ComboboxInput
    className={classNames(
      "bg-primary text-dark w-full cursor-pointer rounded-md border-none py-2.5 pl-4 pr-10 text-md focus:ring-0 disabled:cursor-not-allowed disabled:opacity-40",
      className,
    )}
    displayValue={displayValue}
    onChange={onChange}
    {...rest}
  />
);
